const state = {
  list: [],
}

const getters = {
}

const mutations = {
  setList (state, list) {
    state.list = list
  },
}

const actions = {
  searchKeywordQuery ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/product/search/keyword-query', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
